/**
 * Fuente única de título de pantalla (header operativo): manifiesto + títulos Shell.
 * No usa shortLabel.
 */
import {
  NAVIGATION_MANIFEST,
  resolveNavItemLabel,
  type NavigationManifestItem,
} from './navigationManifest';
import type { BusinessCapability } from '../session/domain/businessProfile';

/** Títulos de rutas Shell que no están (o no solo) en el manifiesto como destino con label. */
const SHELL_PAGE_TITLES: Record<string, string> = {
  SaleDetail: 'Detalle de venta',
  OnlineOrderDetail: 'Pedido online',
  OrdersHistory: 'Historial de pedidos',
  OrderMessageThread: 'Mensajes del pedido',
  ComplaintDetail: 'Reclamo',
  ConsultationDetail: 'Consulta de receta',
  QuoteDetail: 'Cotización',
  AppointmentResources: 'Configurar agendas',
  StoreReviewDetail: 'Reseña',
  ChangeBusinessType: 'Cambiar rubro',
  BusinessFunctions: 'Funciones del negocio',
  OperationMode: 'Funciones del negocio',
  CapabilityBreakdown: 'Funciones del negocio',
  AddFeatures: 'Funciones del negocio',
  MenuOptionGroups: 'Opciones de menú',
  ProductRecipe: 'Receta',
  ProduceRecipe: 'Producir',
  DisassembleRecipe: 'Fraccionar',
  ActivityHistory: 'Actividad de tu cuenta',
  MarketplaceTrust: 'Estado de tu tienda online',
  TeamHistory: 'Historial del equipo',
  EmployeePermissions: 'Permisos por empleado',
  InviteEmployee: 'Invitar empleado',
  ArcaIntegration: 'Facturación electrónica',
  FiscalHub: 'Facturación electrónica',
  MercadoPagoBranchSettings: 'Mercado Pago',
  Glossary: 'Glosario',
  SupportTicketDetail: 'Reporte',
  OnlineComplaints: 'Reclamos online',
  Consultations: 'Consultas de recetas',
  Quotes: 'Cotizaciones',
  More: 'Más',
  Team: 'Equipo',
  Organization: 'Organización',
};

function manifestByRoute(): Map<string, NavigationManifestItem> {
  const map = new Map<string, NavigationManifestItem>();
  for (const item of NAVIGATION_MANIFEST) {
    map.set(item.route, item);
  }
  return map;
}

const MANIFEST_BY_ROUTE = manifestByRoute();

export function resolveScreenPageTitle(
  routeName: string,
  caps?: Set<BusinessCapability> | null,
): string {
  const shell = SHELL_PAGE_TITLES[routeName];
  if (shell) return shell;

  const item = MANIFEST_BY_ROUTE.get(routeName);
  if (item) {
    return resolveNavItemLabel(item, caps ?? undefined);
  }

  return routeName;
}
